import { orderStatusesColorSchema } from 'pages/Monitoring/OrderConversionChart/constants/orderStatusesColorSchema';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { Box } from 'shared/mui/Box';
import { Typography } from 'shared/mui/Typography';
import {
  OrderConversionChartStatuses,
  OrderConversionProviderChartDataset,
} from 'types/embedded/orderConversion';

import { OrderConversionChartProvidersRatioBarTitle } from './OrderConversionChartProvidersRatio.styled';

type Props = OrderConversionProviderChartDataset & {
  title?: string;
};

export const OrderConversionChartProvidersRatioBar: React.FC<Props> = ({
  title,
  providerName,
  failure,
  pending,
  success,
  total,
}) => {
  const translate = useTypedTranslate();
  return (
    <Box>
      <OrderConversionChartProvidersRatioBarTitle>
        <Typography fontSize="12px">{title || providerName}</Typography>
        <Typography color="text.secondary" fontSize="12px">
          <Typography
            component="span"
            sx={{
              fontSize: '12px',
              fontWeight: 500,
              marginRight: '4px',
              color: orderStatusesColorSchema[OrderConversionChartStatuses.Success],
            }}
          >{`${success.percentage}%`}</Typography>
          {`(${success.count} ${translate('app.common.of')} ${total.count})`}
        </Typography>
      </OrderConversionChartProvidersRatioBarTitle>
      <Box sx={{ width: '100%', height: '8px', display: 'flex' }}>
        <div
          style={{
            width: `${success.percentage}%`,
            backgroundColor: orderStatusesColorSchema[OrderConversionChartStatuses.Success],
          }}
        ></div>
        <div
          style={{
            width: `${pending.percentage}%`,
            backgroundColor: orderStatusesColorSchema[OrderConversionChartStatuses.Pending],
          }}
        ></div>
        <div
          style={{
            width: `${failure.percentage}%`,
            backgroundColor: orderStatusesColorSchema[OrderConversionChartStatuses.Failure],
          }}
        ></div>
      </Box>
    </Box>
  );
};
